import styled from '@emotion/styled';
export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;
export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const Label = styled.label`
  font-weight: 500;
  color: #374151;
`;
export const StyledInput = styled.input`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  &:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5);
  }
  &:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
  }
`;
export const StyledTextarea = styled.textarea`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  min-height: 120px;
  resize: vertical;
  &:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5);
  }
  &:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
  }
`;
export const Select = styled.select`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  &:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5);
  }
  &:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
  }
`;
export const FileInputWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;
export const FileInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-grow: 1;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  padding: 0.45rem 0.75rem;
  font-size: 0.875rem;
`;
export const FileName = styled.span`
  color: #4b5563;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
`;
export const ThumbnailPreview = styled.img`
  margin-top: 0.75rem;
  max-width: 200px;
  max-height: 150px;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
`;
export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;
export const PriceInputWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  input[type="number"] {
    flex-grow: 1;
  }
  select {
    width: auto;
    flex-grow: 0;
  }
`;
export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #374151;
  font-weight: normal;
  cursor: pointer;

  input[type="checkbox"] {
    width: 1rem;
    height: 1rem;
    border-radius: 0.25rem;
    border-color: #d1d5db;
    &:checked {
      background-color: #2563eb;
      border-color: #2563eb;
    }
    &:focus {
      outline: 2px solid transparent;
      outline-offset: 2px;
      box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5);
    }
  }
`;
export const RowFlex = styled.div`
  display: flex;
  gap: 1rem;
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;
